


























import {Component, Vue} from "vue-property-decorator"
import ClientsIndex from './clients/Index.vue'
import ClientProjectsIndex from './clients/projects/Index.vue'
import QuotesIndex from './quotes/Index.vue'
import InvoicesIndex from './invoices/Index.vue'

interface Page {
    key: string;
    icon: string;
}

@Component({
    components: {
        ClientsIndex,
        ClientProjectsIndex,
        QuotesIndex,
        InvoicesIndex,
    }
})
export default class Accounting extends Vue {

    private pages: Page[] = [
        { key: 'Clients', icon: 'users' },
        { key: 'Projects', icon: 'project-diagram' },
        { key: 'Quotes', icon: 'quote-right' },
        { key: 'Invoices', icon: 'file-invoice-dollar' },
    ]

    private activePage: string = 'Clients';
}

